import { Link } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
import { getTenantID, getToken, getUser } from "./localStorageFunction";
import { enqueueSnackbar } from "notistack";
import axios from "axios";
import { useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import CheckIcon from "@mui/icons-material/Check"
import ClearIcon from "@mui/icons-material/Clear"

export function getUserRoleFromToken() {
  const userInfo = getUser();

  const userRole = userInfo?.userRole;
  return userRole;
}

export const RenderLink = ({ url, value, state }) => {
  return (
    <Link to={url} state={state}>
      <b>{value}</b>
    </Link>
  );
};

export const printServerPdf = (infoObject, setLoading) => {
  setLoading(true); // START LOADING

  axios
    .post(
      `${process.env.REACT_APP_BASE_URI}${infoObject.url}`,
      {
        entityNumber: infoObject.entityNumber,
        logoUrl: infoObject.logoUrl,
        invoiceType: infoObject?.invoiceType,
      },
      {
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${getToken()}`,
          "X-Tenant-ID": getTenantID(),
        },
        responseType: "blob", // IMPORTANT: To properly handle the PDF response
      }
    )
    .then((res) => {
      const blob = new Blob([res.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);

      // ✅ Open the PDF in an iframe for printing (same tab)
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0px";
      iframe.style.height = "0px";
      iframe.src = pdfUrl;

      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow.print(); // ✅ Trigger print
      };

      enqueueSnackbar("Print page is ready!", { variant: "success" });
    })
    .catch((error) => {
      console.error("Error while loading print page:", error);
      enqueueSnackbar("Error while loading print page!", {
        variant: "error",
      });
    })
    .finally(() => {
      setLoading(false); // STOP LOADING
    });
};

export function GetDeviceType() {
  // Use MUI breakpoints
  const theme = useTheme();
  const isTabletMQ = useMediaQuery(theme.breakpoints.down("md")); // md = 960px
  const isMobileMQ = useMediaQuery(theme.breakpoints.down("sm")); // sm = 600px

  // Use window.innerWidth for more reliability
  const [deviceType, setDeviceType] = useState({
    isTablet: isTabletMQ,
    isMobile: isMobileMQ,
  });

  useEffect(() => {
    function handleResize() {
      setDeviceType({
        isTablet: window.innerWidth < 960,
        isMobile: window.innerWidth < 600,
      });
    }

    // Set initial value
    handleResize();

    // Listen to window resize events
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return deviceType;
}


export function convertDateToDDMMYYYY(dateString) {
  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
}

export function CreditStatusRender({ value }) {
  return (
    <>
      {value?.toString() === "true" ? (
        <CheckIcon color="success" />
      ) : (
        <ClearIcon color="error" />
      )}
    </>
  )
}